var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep5Current(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 68,
    cy: 68,
    r: 68,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 68,
    cy: 68,
    r: 62,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 124C98.9279 124 124 98.9279 124 68C124 37.0721 98.9279 12 68 12C37.0721 12 12 37.0721 12 68C12 98.9279 37.0721 124 68 124Z",
    fill: "#9FB693"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.166 66.818C111.164 69.0613 110.58 71.2656 109.47 73.2152C108.36 75.1648 106.763 76.7929 104.835 77.9402H33.3575C30.898 75.4895 29.4042 72.2344 29.1499 68.7717C28.8956 65.3089 29.8979 61.8706 31.9731 59.0869C29.6705 55.772 28.5566 51.7759 28.8123 47.748C29.0681 43.72 30.6784 39.8969 33.3817 36.8998C36.085 33.9028 39.7223 31.908 43.7026 31.2396C47.683 30.5711 51.7724 31.2684 55.3064 33.218C56.6631 30.9745 58.6051 29.1428 60.9241 27.9196C63.243 26.6964 65.8514 26.1278 68.469 26.2749C71.0867 26.4221 73.6149 27.2793 75.7822 28.7546C77.9495 30.23 79.6741 32.2677 80.7708 34.6491C83.6162 32.874 86.965 32.0805 90.3044 32.39C93.6437 32.6995 96.7896 34.095 99.2603 36.3627C101.731 38.6305 103.39 41.6455 103.984 44.9462C104.578 48.2469 104.074 51.6512 102.549 54.638C105.069 55.5266 107.251 57.1755 108.795 59.3571C110.339 61.5387 111.167 64.1455 111.166 66.818Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1753 44.6667H52.8248C50.0375 44.6667 47.7778 46.7218 47.7778 49.2568V100.743C47.7778 103.278 50.0375 105.333 52.8248 105.333H83.1753C85.9627 105.333 88.2223 103.278 88.2223 100.743V49.2568C88.2223 46.7218 85.9627 44.6667 83.1753 44.6667Z",
    fill: "#302322"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9998 100.667C69.718 100.667 71.1109 99.2738 71.1109 97.5556C71.1109 95.8374 69.718 94.4445 67.9998 94.4445C66.2816 94.4445 64.8887 95.8374 64.8887 97.5556C64.8887 99.2738 66.2816 100.667 67.9998 100.667Z",
    fill: "#534645"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9998 78.8888C69.718 78.8888 71.1109 77.496 71.1109 75.7777C71.1109 74.0595 69.718 72.6666 67.9998 72.6666C66.2816 72.6666 64.8887 74.0595 64.8887 75.7777C64.8887 77.496 66.2816 78.8888 67.9998 78.8888Z",
    fill: "#EEC98A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9998 67.2222C65.6155 67.2222 63.4477 68.1558 61.8281 69.6926C60.8933 70.5796 59.4164 70.5409 58.5294 69.6061C57.6424 68.6712 57.6811 67.1944 58.6159 66.3074C61.063 63.9854 64.3667 62.5555 67.9998 62.5555C71.6329 62.5555 74.9366 63.9854 77.3836 66.3074C78.3185 67.1944 78.3572 68.6712 77.4702 69.6061C76.5832 70.5409 75.1063 70.5796 74.1715 69.6926C72.5519 68.1558 70.3841 67.2222 67.9998 67.2222Z",
    fill: "#EEC98A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 57.8888C63.7647 57.8888 59.9377 59.4469 57.1064 61.9655C56.1435 62.822 54.6687 62.7358 53.8122 61.773C52.9557 60.8102 53.0418 59.3353 54.0047 58.4788C57.6801 55.2093 62.6074 53.2222 68 53.2222C73.3926 53.2222 78.3199 55.2093 81.9953 58.4788C82.9581 59.3353 83.0443 60.8102 82.1878 61.773C81.3313 62.7358 79.8564 62.822 78.8936 61.9655C76.0622 59.4469 72.2352 57.8888 68 57.8888Z",
    fill: "#EEC98A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5Current);
export default __webpack_public_path__ + "static/media/step5-current.b1f94b54f91f83f668e77b8bf51fd6f4.svg";
export { ForwardRef as ReactComponent };